import { render, staticRenderFns } from "./NetWeightPerPackageUnitInput.vue?vue&type=template&id=49007796&scoped=true"
import script from "./NetWeightPerPackageUnitInput.vue?vue&type=script&lang=ts"
export * from "./NetWeightPerPackageUnitInput.vue?vue&type=script&lang=ts"
import style0 from "./NetWeightPerPackageUnitInput.vue?vue&type=style&index=0&id=49007796&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49007796",
  null
  
)

export default component.exports